module.exports = __webpack_public_path__ + "img/checked_gray.edd9c1c4.svg";